import { render, staticRenderFns } from "./DishCompareTable.vue?vue&type=template&id=dd9dc98c&"
import script from "./DishCompareTable.vue?vue&type=script&lang=js&"
export * from "./DishCompareTable.vue?vue&type=script&lang=js&"
import style0 from "./DishCompareTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports